export const WHITE = '#FFF'
export const YELLOW = '#ADA192'
export const BLUE = '#2C405A'
export const LIGHT_BLUE = '#8DABC4'
export const FAINT_BLUE = '#E5EEF5'
export const TEXT_COLOR = '#7E95A7'
export const LIGHT_GREY = '#f2f3f5'

export const TAG_GREEN = '#81C926'
export const TAG_YELLOW = '#FACA00'
export const TAG_BLUE = '#0093EE'
export const TAG_PURPLE = '#AB7DF6'
export const TAG_RED = '#FF151F'


// WEBPACK FOOTER //
// ./src/components/colors.js